import {useState} from 'react'
import {Modal, useOpenModal} from '@/components/Modal'
import Table from '@/components/Table/Table.jsx'

const TableChoose = ({
    dataSource,
    dataSourceArgs = [],
    rowSelection,
    useDataSource = () => ({}),
    onChange,
    onSelect,
    ...props
}) => {
    const {data, isLoading, mutate} = useDataSource(...dataSourceArgs)

    const rs = {
        onChange: (_, selectedRows) => onSelect(selectedRows),
        ...rowSelection,
    }

    const _onChange = rows => {
        mutate(rows, {revalidate: false})
        onChange(rows)
    }

    return (
        <Table
            dataSource={dataSource ?? data}
            isLoading={isLoading}
            rowSelection={rs}
            selectRowOnClick
            onChange={_onChange}
            {...props}
        />
    )
}

const ModalChoose = ({
    allowChooseNone = false,
    columns,
    dataSource,
    dataSourceArgs,
    defaultSelect,
    defaultSelectAll,
    defaultSelectFirst,
    disabled,
    multiple,
    rowKey,
    rowSelection,
    useDataSource,
    onOk,
    ...props
}) => {
    const [selectedRows, setSelectedRows] = useState([])

    const okButtonProps = {
        disabled: ! (allowChooseNone || 0 < selectedRows.length),
    }

    const _onOk = () => onOk(selectedRows)

    const onChange = rows => {
        const keys = new Set(
            selectedRows.map(e => e[rowKey])
        )

        const updatedRows = rows.filter(
            e => keys.has(e[rowKey])
        )

        setSelectedRows(updatedRows)
    }

    return (
        <Modal
            okButtonProps={okButtonProps}
            width={800}
            onOk={_onOk}
            {...props}
        >
            <TableChoose
                columns={columns}
                dataSource={dataSource}
                dataSourceArgs={dataSourceArgs}
                rowKey={rowKey}

                rowSelection={{
                    defaultSelect,
                    defaultSelectAll,
                    defaultSelectFirst,
                    disabled,
                    type: multiple ? 'checkbox' : 'radio',
                    ...rowSelection,
                }}

                useDataSource={useDataSource}
                onChange={onChange}
                onSelect={setSelectedRows}
            />
        </Modal>
    )
}

export default ({
    columns,
    useDataSource,
    ...props
}) => {
    const openModal = useOpenModal()

    return (...dataSourceArgs) => openModal(
        <ModalChoose
            columns={columns}
            dataSourceArgs={dataSourceArgs}
            useDataSource={useDataSource}
            {...props}
        />
    )
}

export const useChooseStatic = props => {
    const openModal = useOpenModal()

    return ({columns, dataSource}) => openModal(
        <ModalChoose
            columns={columns}
            dataSource={dataSource}
            {...props}
        />
    )
}
